import {
  PUT_ROUTES_CATALOG,
  PUT_ROUTES_CATALOG_SUCCESS,
  PUT_ROUTES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putRoutesCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case PUT_ROUTES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_ROUTES_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_ROUTES_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
